import { AppProtocolsDictionary } from '@kentik/ui-shared/dictionary/types';
import { AppProtocolRaw } from '@kentik/ui-shared/types/lookup.types';

export const getAppProtocolsFromRaw = (appProtocols: AppProtocolRaw[]) =>
  appProtocols.reduce((acc, protocol) => {
    const { columns: _columns, app_protocol, ...rest } = protocol;
    acc[app_protocol] = rest;
    return acc;
  }, {} as AppProtocolsDictionary);
